import { StaffActivitiesByDescription } from "../../types";

export const staffActivities: StaffActivitiesByDescription = {
  "Missouri Invoice": {
    parameters: {
      linkUrls: ["https://apps1.mo.gov/merc"],
      staffInputs: {
        fees: true,
        documentTypes: {
          invoice: true,
          receipt: true,
        },
      },
    },
    jurisdictionType: "State",
    activityType: "Invoice",
    consolidated: "Once Per Organization",
    state: "MO",
  },
  "Missouri State Portal": {
    parameters: {
      linkUrls: ["https://apps1.mo.gov/merc"],
      staffInputs: {
        documentTypes: {
          report: true,
        },
      },
    },
    jurisdictionType: "State",
    activityType: "Portal",
    state: "MO",
  },
};
